import React from "react";
import { Container, Row, Col } from "reactstrap";

const Company = () => {
  return (
    <section>
      <h3 style={{textAlign: "center"}}>Polimerlarni qayta ishlash texnologiyasi Majmuasi</h3>
      <Container>
        <Row>
          <Col lg="2" md="3" sm="4" xs="6">
            <h4 className=" d-flex align-items-center gap-1">
              <a href="https://drive.google.com/file/d/1Pp3GpECvCGr4Vva2r8VcGPzaM4s89Zv0/view?usp=sharing">
                {" "}
                <i class=""></i> Polilmer QIT ishchi
              </a>
            </h4>
          </Col>

          <Col lg="2" md="3" sm="4" xs="6">
            <h4 className=" d-flex align-items-center gap-1">
              <a href="https://drive.google.com/file/d/1oLDW9CT9o2lm0VkqbTh4N_WxZ2DLuZ-l/view?usp=sharing">
                {" "}
                <i class=""></i> Polimer QIT adabiyot
              </a>
            </h4>
          </Col>

          <Col lg="2" md="3" sm="4" xs="6">
            <h4 className=" d-flex align-items-center gap-1">
              <a href="https://drive.google.com/file/d/1qIqB8LFmcEdF5_HqAG8fLALCMcUVXOku/view?usp=sharing">
                <i class=""></i> Polimer QIT amaliy
              </a>
            </h4>
          </Col>

          <Col lg="2" md="3" sm="4" xs="6">
            <h4 className=" d-flex align-items-center gap-1">
              {" "}
              <a href="https://drive.google.com/file/d/1Y9z-4oWFCTniwr76q1ZM7OKLYl1HeWn9/view?usp=sharing">
                {" "}
                <i class=""></i> Polimer QIT glossariy
              </a>
            </h4>
          </Col>

          <Col lg="2" md="3" sm="4" xs="6">
            <h4 className=" d-flex align-items-center gap-1">
              {" "}
              <a href="https://drive.google.com/file/d/1O_iwE8oqeOfpL-J-hg3k9CqLIzwY37o2/view?usp=sharing">
                <i class=""></i> Polimer QIT laboratoriya
              </a>
            </h4>
          </Col>

          <Col lg="2" md="3" sm="4" xs="6">
            <h4 className=" d-flex align-items-center gap-1">
              {" "}
              <a href="https://drive.google.com/file/d/1fYsvsFCAnTTu9wXucKJ76LexXg5T3Dbi/view?usp=sharing">
                <i class=""></i> Polimer QIT ma'ruza
              </a>
            </h4>
          </Col>
          <Col lg="2" md="3" sm="4" xs="6">
            <h4 className=" d-flex align-items-center gap-1">
              {" "}
              <a href="https://drive.google.com/file/d/1ABlWjq9gAmmUCFMB34MVlOrYvQRjz_3y/view?usp=sharing">
                <i class=""></i> Polimer <br/>QIT namunaviy
              </a>
            </h4>
          </Col>
          <Col lg="2" md="3" sm="4" xs="6">
            <h4 className=" d-flex align-items-center gap-1">
              {" "}
              <a href="https://drive.google.com/file/d/1RbOtidfQHfEO8rLqsw_SQPuD9la7kQ2y/view?usp=sharing">
                <i class=""></i> Polimer QIT ped tex
              </a>
            </h4>
          </Col>
          <Col lg="2" md="3" sm="4" xs="6">
            <h4 className=" d-flex align-items-center gap-1">
              {" "}
              <a href="https://drive.google.com/file/d/1TFdv5cNqHtsmiivYN_7sD3rtwzPtwGpq/view?usp=sharing">
              <i class=""></i> Polimer QIT savol
              </a>
            </h4>
          </Col>
          <Col lg="2" md="3" sm="4" xs="6">
            <h4 className=" d-flex align-items-center gap-1">
              {" "}
              <a href="https://drive.google.com/file/d/1TFdv5cNqHtsmiivYN_7sD3rtwzPtwGpq/view?usp=sharing">
              <i class=""></i> Polimer QIT test
              </a>
            </h4>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Company;
